import { CartLinesUpdateEvent } from '@shopify/events';
import { morph } from '@theme/morph';
let busy = false;
class BloomDonation extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onChange);
  }
  disconnectedCallback() { this.removeEventListener('change', this.onChange); }
  onChange = async (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || busy) return;
    const wanted = input.checked;
    const root = window.Shopify?.routes?.root || '/';
    const drawer = this.closest('theme-drawer');
    const buttons = [...(drawer?.querySelectorAll('button[name="checkout"]') || [])];
    const states = buttons.map(button => button.disabled);
    const message = this.querySelector('[data-donation-error]');
    busy = true;
    input.disabled = true;
    buttons.forEach(button => button.disabled = true);
    message.textContent = '';
    const read = async (path, options) => {
      const response = await fetch(root + path, options);
      const result = await response.json();
      if (!response.ok || result.errors) throw new Error(result.description || result.message || 'Unable to update contribution. Please try again.');
      return result;
    };
    const post = body => ({ method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body) });
    try {
      let cart = await read('cart.js');
      const matches = cart.items.filter(item => String(item.variant_id) === this.dataset.variant && !item.selling_plan_allocation);
      if (wanted && !matches.length) {
        await read('cart/add.js', post({items:[{id:this.dataset.variant,quantity:1}]}));
      } else if (!wanted && matches.length) {
        await read('cart/update.js', post({updates:Object.fromEntries(matches.map(item => [item.key,0]))}));
      }
      cart = await read('cart.js');
      const sectionsResponse = await fetch(root + '?sections=cart-drawer-section');
      if (!sectionsResponse.ok) throw new Error('Contribution updated. Refresh the page to see the latest total.');
      const sections = await sectionsResponse.json();
      if (!sections['cart-drawer-section']) throw new Error('Contribution updated. Refresh the page to see the latest total.');
      const html = new DOMParser().parseFromString(sections['cart-drawer-section'], 'text/html');
      const current = drawer?.querySelector('.cart-drawer__inner');
      const replacement = html.querySelector('.cart-drawer__inner');
      if (!current || !replacement) throw new Error('Contribution updated. Refresh the page to see the latest total.');
      morph(current, replacement);
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: wanted ? 'add' : 'remove', context:'cart', lines:[],
        promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections,items:cart.items,itemCount:cart.item_count,source:'bloom-donation',didError:false}})
      }));
    } catch (error) {
      if (this.isConnected) {
        message.textContent = error.message || 'Unable to update contribution.';
        try {
          const cart = await read('cart.js');
          input.checked = cart.items.some(item => String(item.variant_id) === this.dataset.variant && !item.selling_plan_allocation);
        } catch { input.checked = !wanted; }
      }
    } finally {
      busy = false;
      input.disabled = false;
      buttons.forEach((button,index) => { if(button.isConnected) button.disabled = states[index]; });
      drawer?.querySelectorAll('bloom-donation input').forEach(el => el.disabled = false);
    }
  };
}
if (!customElements.get('bloom-donation')) customElements.define('bloom-donation', BloomDonation);
